<template>
  <div>
    <div class="grid gap-4 py-6 border-t bg-gray-50 md:grid-cols-3 auto-rows-auto lg:grid-cols-5">
      <DatePicker class="md:col-span-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="w-40 form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 border bg-gray-50">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="w-40 form-input append"
            />
          </div>
        </template>
      </DatePicker>
      <filter-dropdown button-class="" button-text="More Filters" :hide-buttons="true">
        <fieldset class="form-group">
          <label class="form-label">Breakdown by</label>
          <select name="" id="" class="form-select" v-model="filter.breakdown_by">
            <option value="driver">Driver</option>
            <option value="vehicle">Vehicle</option>
          </select>
        </fieldset>
        <fieldset class="form-group">
          <label for="filterZero" class="form-label">
            <input id="filterZero" type="checkbox" class="mt-0.5 mr-2 form-checkbox" v-model="filter.hide_zero_values">  
            Filter Out 0 Values
          </label>
        </fieldset>
      </filter-dropdown>
    </div>

    <template v-if="report">
      <div class="card">
        <div class="flex flex-col justify-between p-4 border-b md:flex-row lg:p-5">
          <button class="ml-auto btn btn-sm btn-outline" @click="$parent.downloadReport()" v-submitting="$parent.submitting">
            <fa :icon="['far', 'arrow-to-bottom']" class="mr-2" /> Download
          </button>
        </div>
        <div class="divide-y">
          <div v-for="row in report.rows" :key="row.id" class="px-4 py-6">
            <div class="flex justify-between">
              <div class="font-bold">
                {{ row.name }}
              </div>
              <div>
                {{ totalDuration(row.total_driving_time) }}
              </div>
            </div>
            <div class="relative flex h-4 mt-1 overflow-hidden bg-gray-100">
              <div 
                v-for="trip in row.trips" 
                :key="trip.id"
                v-tooltip="tripTooltip(trip)"
                class="absolute bottom-0 h-full bg-gray-400 hover:bg-indigo-500"
                :style="{
                  width: trip.percentage_of_period + '%',
                  left: trip.start_percentage + '%'
                }">
              </div>
            </div>
            <div class="flex justify-between w-full mt-1 text-xs text-gray-500">
              <div>{{ report.meta.filter.date.start | moment('DD/MM HH:mm') }}</div>
              <div>{{ report.meta.filter.date.end | moment('DD/MM HH:mm') }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import { sub } from 'date-fns'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import FilterDropdown from '@/components/FilterDropdown'

export default {
  name: 'DrivingTimeReport',

  components: {
    DatePicker,
    FilterDropdown
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    params () {
      return { 
        filter: this.filter
      }
    }
  },

  data () {
    return {
      filter: {
        date: {
          start: sub(new Date(), { hours: 6 }),
          end: new Date()
        },
        breakdown_by: 'driver',
        hide_zero_values: false
      }
    }
  },

  methods: {
    totalDuration (time) {
      let hours = time / 3600
      let minutes = time % 3600 / 60

      if (hours < 1) {
        return `${minutes.toFixed()}min`
      } else {
        return `${hours.toFixed()}hr ${minutes.toFixed()}min`
      }
    },

    tripTooltip (trip) {
      let from = moment(trip.start_time).format('DD/MM HH:mm')
      let to = moment(trip.end_time).format('DD/MM HH:mm')
      let hours = trip.duration / 3600
      let minutes = trip.duration % 3600 / 60
      
      return `<div class="text-center">
        <div class="font-bold">${hours.toFixed()}hr ${minutes.toFixed()}min</div>
        <div class="text-gray-400">${from} &rarr; ${to}</div>
      </div>`
    }
  }
}
</script>